import { Navigate } from 'react-router-dom';
// CUSTOM DEFINED HOOK
import useAuth from 'hooks/useAuth';
import permissionsAccess from 'utils/permissionsAccess';
import permissionsList from 'constants/permissionsList';

export default function TripsAccessGuard({ children }) {
  const { role, loading } = useAuth();

  // Wait for auth to load before checking permissions
  if (loading || !role) {
    return <>{children}</>;
  }

  const { showInMenu: hasTripsAccess } = permissionsAccess(
    role,
    permissionsList.Trip
  );

  if (!hasTripsAccess) {
    const availablePages = [
      { path: '/dashboard', permission: permissionsList.Dashboard },
      { path: '/dashboard/patients', permission: permissionsList.Patient },
      { path: '/admin/vehicles', permission: permissionsList.Vehicle },
      { path: '/admin/drivers', permission: permissionsList.Driver },
      {
        path: '/admin/roles-and-permissions',
        permission: permissionsList.RolesAndPermissions
      },
      { path: '/admin/user-list/list', permission: permissionsList.Users },
      { path: '/admin/groups', permission: permissionsList.VehicleGroup },
      {
        path: '/admin/vehicle-types',
        permission: permissionsList.VehicleType
      },
      {
        path: '/dashboard/level-of-service',
        permission: permissionsList.LevelOfService
      }
    ];

    for (const page of availablePages) {
      const { showInMenu } = permissionsAccess(role, page.permission);
      if (showInMenu) {
        return <Navigate to={page.path} replace />;
      }
    }

    // If no permissions at all, show access denied or redirect to login
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
